var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 29,
  viewBox: "0 0 29 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.333 25a2.3 2.3 0 0 1-1.681-.7 2.3 2.3 0 0 1-.7-1.681V7.143h-1.19V4.762h5.952v-1.19h7.143v1.19h5.952v2.38h-1.19V22.62q0 .982-.7 1.682-.699.699-1.681.699zM20.238 7.143H8.333v15.476h11.905zm-9.524 13.095h2.381V9.524h-2.38zm4.762 0h2.381V9.524h-2.381z"
})));
export default SvgDelete;